module.exports = __webpack_public_path__ + "static/media/error-img.c7ae99ce.png";